<template>
    <div class="product card" >
        <!-- col col-xs-12 col-sm-4 col-md-3 pb-3 -->
        <div class="">
            <!-- <div class="card-header"> 
                <button type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div> -->
            <div class="card-body">
                <div class="text-center preview-img" :style="{ backgroundImage: 'url(\'' + productImages[0] + '\')' }"  >
                   <div class="row">
                       <div class="col-xs-6 text-left">
                            <div class="share-product" @click="showLink = true"><span class="glyphicon glyphicon-share-alt"></span></div>
                            <modal-share-link v-if="showLink" @close="showLink = false" :productid="product.id" :pageid="selectedBot.pageid"></modal-share-link>
                        </div>

                        <div class="col-xs-6 text-right">
                            <div class="text-center sale-tag" v-if="discountPercentage > 0">
                                Sale <br>
                                {{ discountPercentage | numberFormat}}%
                            </div>
                        </div>
                   </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <div style="padding:15px;border-bottom: 1px solid #eee">
                            <div class="name" :title="product.name">{{ product.name  | truncate(20)}}</div>
                            <div class="price"><template v-if="discountPriceRange != priceRange">{{ discountPriceRange }}</template><template v-else>{{ priceRange }}</template></div>
                            <div class="discount" v-if="discountPriceRange != priceRange">{{ priceRange }}</div><div v-else class="discount"></div>
                        </div>
                        
                    </div>
                    <div class="col-xs-12">
                        <div style="overflow-y:auto;height: 100px;padding:10px 0 10px 10px;">
                            <template v-if="product.productstock && product.productstock.length > 0">
                                <stock-item v-for="(stock, sindex) in product.productstock" :key="'stock_'+sindex" v-model="product.productstock[sindex]" :productId="product.id"></stock-item>
                            </template>
                            <template v-else>
                                <div class="text-center">
                                    No stock
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                
                
            </div>
            <div class="card-footer">
                <div class="row">
                    <div class="card-btn col-xs-12 text-center"><a href="javascript:void(0);" @click="showModal = true">Edit</a></div>

                    
                </div>
            </div>
        </div>

        <modal-edit-product v-if="showModal" v-model="product" @close="close()" @productDeleted="$emit('productDeleted')" :selectCategory="selectCategory" :category="category"></modal-edit-product>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StockItem from './StockItem.vue';
import ModalEditProduct from './ModalEditProduct'
import ModalShareLink from './ModalShareLink'
import numeral from 'numeral'

    export default {
        props: ['value','category','selectCategory'],
        data: function(){
            return {
                product: this.value,

                showModal: false,
                showLink: false
            }
        },
        components: {
            ModalEditProduct,
            StockItem,
            ModalShareLink
        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot'
            }),
            productImages: function(){
                return this.product.photourl.split(';;')
            } ,
            currencySign: function() {
            if (this.product && this.product.currency) {
                switch (this.product.currency.toUpperCase()) {
                    case "THB":
                        return "฿";

                    default:
                        return "$";
                    }
                }
                return "$";
            },
            priceRange: function(){
                var min = 0
                var max = 0

                for (let index = 0; index < this.product.productstock.length; index++) {
                    var price = this.product.productstock[index][3] == null || this.product.productstock[index][3] == '' ? parseFloat(this.product.price) : parseFloat(this.product.productstock[index][3])
                    if (index == 0) {
                        min = price
                        max = price
                    } else {
                        if (price > max) {
                            max = price
                        }
                        if (price < min) {
                            min = price
                        }
                    } 
                }

                if (min == max) {
                    return this.currencySign + numeral(min).format("0,0.00")
                } else {
                    return this.currencySign + numeral(min).format("0,0.00") + ' - ' + this.currencySign + numeral(max).format("0,0.00")
                }
            },
            discountPriceRange: function(){
                var min = 0
                var max = 0

                for (let index = 0; index < this.product.productstock.length; index++) {
                    var price = this.product.productstock[index][3] == null || this.product.productstock[index][3] == '' ? parseFloat(this.product.discountprice) : parseFloat(this.product.productstock[index][3])
                    var discountprice = this.product.productstock[index][4] == null || this.product.productstock[index][4] == '' ? price : parseFloat(this.product.productstock[index][4])
                    
                    if (index == 0) {
                    min = discountprice
                    max = discountprice
                    } else {
                        if (discountprice > max) {
                            max = discountprice
                        }
                        if (discountprice < min) {
                            min = discountprice
                        }
                    } 
                }

                if (min == max) {
                    return this.currencySign + numeral(min).format("0,0.00")
                } else {
                    return this.currencySign + numeral(min).format("0,0.00") + ' - ' + this.currencySign + numeral(max).format("0,0.00")
                }
            },
            discountPercentage: function(){
                var max = 0
                
                for (let index = 0; index < this.product.productstock.length; index++) {
                    var price = this.product.productstock[index][3] == null || this.product.productstock[index][3] == '' ? parseFloat(this.product.price) : parseFloat(this.product.productstock[index][3])
                    var discountprice = this.product.productstock[index][4] == null || this.product.productstock[index][4] == '' ? price : parseFloat(this.product.productstock[index][4])
                    
                    if (index == 0) {
                        max = ((price - discountprice) / price ) * 100
                    } else {
                        var percent = ((price - discountprice) / price ) * 100
                        if (max < percent) {
                            max = percent
                        }
                    }
                }

                return max
            }
        },
        methods: {
            close: function(){
                let vm = this
                vm.showModal = false
                $("body").removeClass("modal-open");
                vm.$nextTick(function(){
                    vm.$emit('input',vm.product)
                })
            }
        },
        watch: {
            value : function(newVal,oldVal){
                if (newVal != oldVal) {
                    // this.product = this.value
                }
            },
            showModal: function(newVal, oldVal) {
                if (newVal) {
                    $("body").addClass("modal-open");
                } else {
                    $("body").removeClass("modal-open");
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Product.vue